import { IQueryState } from './IQueryState';
export const initialState: IQueryState = {
  byId: {},
};
